import { createContext, useMemo, useState, type ReactNode } from "react";
import useEvent from "react-use-event-hook";
import { RecoilRoot } from "recoil";

export interface ISessionStoreContext {
  rebootSession: () => void;
}

export const SessionStoreContext = createContext<
  ISessionStoreContext | undefined
>(undefined);

interface ISessionStoreProviderProps {
  children: ReactNode;
}

export const SessionStoreProvider = ({
  children,
}: ISessionStoreProviderProps): ReactNode => {
  const [sessionKey, setSessionKey] = useState(0);

  const rebootSession = useEvent((): void => {
    setSessionKey(key => key + 1);
  });

  const value = useMemo(
    () => ({ rebootSession }) satisfies ISessionStoreContext,
    [rebootSession],
  );

  return (
    <SessionStoreContext.Provider value={value}>
      <RecoilRoot key={sessionKey}>{children}</RecoilRoot>
    </SessionStoreContext.Provider>
  );
};
